import { ServiceListItem } from '@spike/appointments-list-model';
import { FunctionComponent } from 'react';
import styles from './InHomeTag.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { faHouse } from '@fortawesome/pro-light-svg-icons/faHouse';

interface InaHomeTagProps {
    className?: string;
}

export const InHomeTag: FunctionComponent<InaHomeTagProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <FontAwesomeIcon
                icon={faHouse}
                className={styles.icon}
            />
            <span className={styles.text}>Home Service</span>
        </div>
    );
};

export default InHomeTag;
